import { DownloadOutlined, SaveOutlined, SearchOutlined, SendOutlined, ArrowLeftOutlined, ReloadOutlined, DeleteOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { formatVND } from '../../helpers/common';
import { ChiTietLuongThemGioItem, LuongThemGioInfo } from '../../models/luong/LuongThemGio';
import TableChiTietLuongThemGio from '../../modules/salary/TableChiTietLuongThemGio';
import { chiTietLuongThemGio, duyetLuongThemGio, layThongTinLuongThemGio, luuLuongThemGio, taiDuLieuLuongThemGio, xoaBangLuongThemGio, xuatExcelLuongThemGio } from '../../services/luong';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { Links } from '../../helpers/Links';

const ChiTietLuongThemGio = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const [id, setId] = useState<number>(0);
    const [info, setInfo] = useState<LuongThemGioInfo | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [tuKhoa, setTuKhoa] = useState<string>('');

    const [data, setData] = useState<ChiTietLuongThemGioItem[]>([]);
    const [rawData, setRawData] = useState<ChiTietLuongThemGioItem[]>([]);

    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [changedRowIds, setChangedRowIds] = useState<Set<number>>(new Set());
    const [reload, setReload] = useState<boolean>(false);
    const [isShowModalDuyet, setIsShowModalDuyet] = useState<boolean>(false);
    const [isShowModalXoa, setIsShowModalXoa] = useState<boolean>(false);
    const [ghiChu, setGhiChu] = useState<string>('');
    //const [isShowModalCapNhat, setIsShowModalCapNhat] = useState<boolean>(false);

    const setChiTiet = (items: ChiTietLuongThemGioItem[]) => {
        setRawData(items);
        setData(items);
    };

    const layThongTin = async (salaryId: number) => {
        dispatch(showLoadingScreen());
        setLoading(true);
        try {
            const rs = await layThongTinLuongThemGio(salaryId);
            setInfo(rs);
            setGhiChu(rs?.ghiChu ?? '');

            const ct = await chiTietLuongThemGio(salaryId);
            setChiTiet(ct ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        setLoading(false);
        dispatch(hideLoadingScreen());
    };

    const handleTinh = async () => {
        dispatch(showLoadingScreen());
        setLoading(true);
        try {
            const ct = await taiDuLieuLuongThemGio(id);
            setChiTiet(ct ?? []);
            setChangedRowIds(new Set());
            setIsEdit(false);
            toast.success('Tính lương thêm giờ thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        setLoading(false);
        dispatch(hideLoadingScreen());
    };

    const handleLuu = async () => {
        dispatch(showLoadingScreen());
        try {
            await luuLuongThemGio({ id, ghiChu, chiTiet: rawData });
            toast.success('Lưu lương thêm giờ thành công');
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleDuyet = async () => {
        dispatch(showLoadingScreen());
        try {
            await duyetLuongThemGio(id);
            toast.success('Xác nhận lương thêm giờ thành công');
            setIsShowModalDuyet(false);
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXoa = async () => {
        dispatch(showLoadingScreen());
        try {
            await xoaBangLuongThemGio(id);
            toast.success('Xóa bảng lương thêm giờ thành công');
            navigate(Links.Luong.DanhSachLuongThemGio);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleExportExcel = async () => {
        if (!id) return;
        dispatch(showLoadingScreen());
        try {
            const res = await xuatExcelLuongThemGio(id);
            if (res && res.data) {
                const blob = new Blob([res.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${info?.tenKyLuong ?? 'Luong_Them_Gio'}.xlsx`;
                link.click();
                window.URL.revokeObjectURL(link.href);
            }
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', '') || 'Xuất Excel thất bại');
        }
        dispatch(hideLoadingScreen());
    };

    const onChangeItem = (index: number, field: string, value: any) => {
        if (field !== 'soTienDuocNhan') return;

        const updated = [...data];
        const row = { ...updated[index], soTienDuocNhan: Number(value) || 0 };
        updated[index] = row;
        setData(updated);

        // Chênh lệch quỹ lương sẽ tự cập nhật vì được tính lại từ rawData ở phần render.
        const full = [...rawData];
        const idx = full.findIndex((x) => x.id === row.id);
        if (idx >= 0) {
            full[idx] = row;
            setRawData(full);
        }

        setChangedRowIds((prev) => {
            const ns = new Set(prev);
            ns.add(row.id);
            return ns;
        });
    };

    /*const handleLuuDieuChinh = async () => {
        if (changedRowIds.size === 0) {
            toast.warning('Không có dữ liệu thay đổi!');
            return;
        }

        dispatch(showLoadingScreen());
        try {
            const items = rawData
                .filter((x) => changedRowIds.has(x.id))
                .map((x) => ({
                    id: x.id,
                    themGioNgayThuong: x.themGioNgayThuong,
                    themGioNgayNghi: x.themGioNgayNghi,
                    themGioNgayLe: x.themGioNgayLe,
                    tienNgayThuong: x.tienNgayThuong,
                    tienNgayNghi: x.tienNgayNghi,
                    tienNgayLe: x.tienNgayLe,
                    soTienDuocNhan: x.soTienDuocNhan,
                    ghiChu: x.ghiChu
                }));

            await luuDieuChinhChiTietLuongThemGio({ items });

            toast.success(`Lưu điều chỉnh thành công (${items.length} dòng)`);
            setChangedRowIds(new Set());
            setIsEdit(false);
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };*/

    const search = () => {
        const kw = (tuKhoa || '').toLowerCase();

        setData(
            rawData.filter(
                (x) =>
                    !kw ||
                    (x.hoTen ?? '').toLowerCase().includes(kw) ||
                    (x.ma ?? '').toLowerCase().includes(kw) ||
                    (x.tenDonVi ?? '').toLowerCase().includes(kw)
            )
        );
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const salaryId = urlParams.get('id');

        if (salaryId) {
            setId(Number(salaryId));
            layThongTin(Number(salaryId));
        }
    }, [location.search]);

    useEffect(() => {
        if (reload && id > 0) {
            setReload(false);
            layThongTin(id);
        }
    }, [reload]);

    const isDaDuyet = (info?.trangThai ?? 0) === 1;

    const tongNhanSu = rawData.length;
    const tongTienDuocNhan = rawData.reduce((s, x) => s + (x.soTienDuocNhan ?? 0), 0);

    return (
        <section>
            <ContentHeader title={info?.tenKyLuong ?? 'Lương thêm giờ'} />

            <Row className="form-group" gutter={8}>
                <Col xs={22} sm={14} md={8}>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="Nhập tên, mã nhân viên, đơn vị"
                        value={tuKhoa}
                        onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') search();
                        }}
                    />
                </Col>

                <Col xs={2} sm={2} md={0}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search} />
                </Col>

                <Col xs={0} sm={0} md={4}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search}>
                        Tìm kiếm
                    </Button>
                </Col>

                <Col xs={24} sm={24} md={12}>
                    <Space className="float-right">
                        <Button type="default" icon={<ArrowLeftOutlined />} onClick={() => { navigate(Links.Luong.DanhSachLuongThemGio) } }>
                                Quay lại
                        </Button>
                        {!isDaDuyet && (
                            <Button
                                danger
                                type="primary"
                                icon={<DeleteOutlined />}
                                onClick={() => setIsShowModalXoa(true)}
                            >
                                Xóa dữ liệu
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button type="primary" icon={<DownloadOutlined />} onClick={handleTinh}>
                                Tính lương
                            </Button>
                        )}

                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<SendOutlined />}
                                onClick={() => setIsShowModalDuyet(true)}
                            >
                                Xác nhận
                            </Button>
                        )}

                        {!isDaDuyet && (
                            <Button
                                className="hrm-btn hrm-btn-warning"
                                icon={<SaveOutlined />}
                                onClick={handleLuu}
                            >
                                Lưu
                            </Button>
                        )}
                        <Button
                            className="hrm-btn hrm-btn-success"
                            icon={<FileExcelOutlined />}
                            onClick={handleExportExcel}
                        >
                            Xuất Excel
                        </Button>
                    </Space>
                </Col>
            </Row>

            <Row gutter={8} className="form-group">
                <Col xs={24} sm={8} md={8}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Tổng tiền được nhận
                        </div>
                        <div className="text-bold text-center">{formatVND(tongTienDuocNhan)}</div>
                    </div>
                </Col>

                <Col xs={24} sm={8} md={8}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Số nhân sự
                        </div>
                        <div className="text-bold text-center">{tongNhanSu}</div>
                    </div>
                </Col>

                <Col xs={24} sm={16} md={8}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Trạng thái
                        </div>
                        <div className="text-bold text-center">
                            {isDaDuyet ? (
                                <span style={{ color: '#52c41a' }}>Đã xác nhận</span>
                            ) : (
                                <span style={{ color: '#faad14' }}>Chưa xác nhận</span>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
 
            <Row gutter={8} className="form-group">
                <Col span={24}>
                    <div className="card card-primary" style={{ padding: '15px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Ghi chú</div>
                        {!isDaDuyet ? (
                            <Input.TextArea
                                rows={3}
                                placeholder="Nhập ghi chú..."
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        ) : (
                            <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                                {ghiChu || 'Không có ghi chú'}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={<></>
                                // <Space>
                                //     {coTheDieuChinh && (
                                //         <Button
                                //             style={{ width: '140px' }}
                                //             type="default"
                                //             onClick={() => {
                                //                 if (isEdit && changedRowIds.size > 0) {
                                //                     layThongTin(id);
                                //                     setChangedRowIds(new Set());
                                //                 }

                                //                 setIsEdit(!isEdit);
                                //             }}
                                //             icon={
                                //                 isEdit ? (
                                //                     <LockOutlined style={{ color: 'red' }} />
                                //                 ) : (
                                //                     <EditOutlined style={{ color: '#007bff' }} />
                                //                 )
                                //             }
                                //         >
                                //             {isEdit ? 'Khóa' : 'Điều chỉnh'}
                                //         </Button>
                                //     )}

                                //     {isEdit && changedRowIds.size > 0 && (
                                //         <Button
                                //             className="hrm-btn hrm-btn-warning"
                                //             icon={<SaveOutlined />}
                                //             onClick={handleLuuDieuChinh}
                                //         >
                                //             Lưu điều chỉnh ({changedRowIds.size})
                                //         </Button>
                                //     )}
                                // </Space>
                            }
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: '1',
                                    label: 'Bảng lương thêm giờ',
                                    children: (
                                        <TableChiTietLuongThemGio
                                            loading={loading}
                                            dataSource={data}
                                            isEdit={isEdit}
                                            onChangeItem={onChangeItem}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </div>
                </Col>
            </Row>

            <ModalTextForm
                show={isShowModalDuyet}
                title="Xác nhận lương thêm giờ"
                handleClose={() => setIsShowModalDuyet(false)}
                handleSave={handleDuyet}
            >
                Bạn có chắc muốn xác nhận lương thêm giờ{' '}
                <b>{info?.tenKyLuong ?? ''}</b> không?
            </ModalTextForm>

            <ModalTextForm
                show={isShowModalXoa}
                title="Xóa bảng lương thêm giờ"
                handleClose={() => setIsShowModalXoa(false)}
                handleSave={handleXoa}
            >
                Bạn có chắc chắn muốn xóa bảng lương thêm giờ <b>{info?.tenKyLuong ?? ''}</b>? Hành động này sẽ xóa toàn bộ dữ liệu chi tiết của bảng lương.
            </ModalTextForm>
        </section>
    );
};

export default ChiTietLuongThemGio;